import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPlusLarge: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconPlusLarge"><Path fillRule="evenodd" clipRule="evenodd" d="M13 3V11H21V13H13V21H11V13H3V11H11V3H13Z" fill="currentColor"/></CentralIconBase>;
});

export default IconPlusLarge;
